import { PostSectionWeb } from '@nucleus/types/web';
import { useSection } from '@nucleus/web-theme';
import { nucleusClass } from '@nucleus/web-theme-elements';
import classNames from 'classnames';
import React from 'react';
import { getSectionClasses } from '../../lib/classes';
import { Section } from '../../sectionLayouts/Section';
import { SectionLayout } from '../../sectionLayouts/SectionLayout';
import { PostBlockLayoutCollage } from './PostBlockLayoutCollage';
import { PostBlockLayoutContentOnly } from './PostBlockLayoutContentOnly';
import { PostBlockLayoutCover } from './PostBlockLayoutCover';
import { PostBlockLayoutHorizontal } from './PostBlockLayoutHorizontal';
import { PostBlockLayoutLongText } from './PostBlockLayoutLongText';
import { PostBlockLayoutVertical } from './PostBlockLayoutVertical';
import { PostBlockLayoutProps } from './PostLayout';

export const PostSection = (): JSX.Element => {
  const section = useSection<PostSectionWeb>();

  const blockProps = { ...section.payload };
  delete blockProps.backgroundMedia;

  return (
    <Section className={classNames(nucleusClass('section-post'), getSectionClasses(section))}>
      <SectionLayout {...section.payload} height="small">
        <BlockLayout {...blockProps} />
      </SectionLayout>
    </Section>
  );
};

const BlockLayout = (props: PostBlockLayoutProps) => {
  switch (props.blockLayout) {
    case 'layout1':
      return <PostBlockLayoutHorizontal {...props} />;
    case 'layout2':
      return <PostBlockLayoutVertical {...props} />;
    case 'layout3':
      return <PostBlockLayoutCollage {...props} />;
    case 'layout4':
      return <PostBlockLayoutLongText {...props} />;
    case 'layout5':
      return <PostBlockLayoutCover {...props} />;
    case 'layout6':
      return <PostBlockLayoutContentOnly {...props} />;
    default:
      return <PostBlockLayoutHorizontal {...props} />;
  }
};
